import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import isMobile from 'store/app/selector/isMobile';
import OpButton from 'components/Common/op-ui-wrappers/OpButton/OpButton';
import gtmSendEventAsync from 'utils/gtm/gtmSendEventAsync';
import styles from './BringBackMemories.module.scss';

interface BringBackMemoriesProps {
  description: string;
}

const BringBackMemories = ({ description }: BringBackMemoriesProps) => {
  const { t } = useTranslation();
  const isMobileDevice = useSelector(isMobile);

  const headerVariant = isMobileDevice ? 'title-large-bold' : 'headline-large-bold';
  const descriptionVariant = isMobileDevice ? 'label-large-regular' : 'title-medium-regular';

  const navigateToHomePage = async () => {
    await gtmSendEventAsync({
      event: 'create-new-clicked',
      eventCategory: 'memory-lane',
      eventAction: 'create-new',
    });
    window.location.href = '/home-customer';
  };

  return (
    <div className={styles.header}>
      <OpText variant={headerVariant} dangerouslySetInnerHTML={{ __html: t('txt_bring_memories_back') }} />
      <OpText
        variant={descriptionVariant}
        className={styles.description}
        dangerouslySetInnerHTML={{ __html: t(description) }}
      />
      <div className={styles.button}>
        <OpButton onClick={navigateToHomePage} size="medium" variant="primary" block>
          {t('txt_create_new_memory')}
        </OpButton>
      </div>
    </div>
  );
};

export default BringBackMemories;
